module.exports = __webpack_public_path__ + "static/media/test20_2.3436bd89.png";